body.on('click', '#dlf-init-timer-lockout', function () {
    let dlfPriceZonesRadio = $('.DLF_price_zones_radio:checked');

    if (dlfPriceZonesRadio.length === 0) {
        return;
    }

    let data = {
        zones: $(dlfPriceZonesRadio).val(),
    };

    storeTimerLockout(
        data,
        'DLF',
        callbackTimerLockoutDLF
    );
});

function callbackTimerLockoutDLF() {
    $('input[name="forbidden_store"]').remove();
}


body.on('change', '#vlc_zone_1, #vlc_zone_2, #vlc_zone_3', function () {
    let vlcZone1 = $('#vlc_zone_1');
    let vlcZone2 = $('#vlc_zone_2');
    let vlcZone3 = $('#vlc_zone_3');

    let vlcZones = parseInt($('.VLC_price_radio:checked').val());

    let vlcZone1HasValue = vlcZone1.val() !== '' && vlcZone1.val() !== null;
    let vlcZone2HasValue = vlcZone2.val() !== '' && vlcZone2.val() !== null;
    let vlcZone3HasValue = vlcZone3.val() !== '' && vlcZone3.val() !== null;

    let wrapper = $('#vlc-init-timer-lockout-wrapper');
    if (
        parseInt($(wrapper).data('should-hide')) !== 1 &&
        (
            (vlcZones === 1 && vlcZone1HasValue) ||
            (vlcZones === 2 && vlcZone1HasValue && vlcZone2HasValue) ||
            (vlcZones === 3 && vlcZone1HasValue && vlcZone2HasValue && vlcZone3HasValue)
        )
    ) {
        $('#vlc-init-timer-lockout-wrapper').removeClass('d-none');
    }
})
